export default __webpack_public_path__ + "static/media/logo-vendor-simple.4fb63359.svg";